import React, { useEffect, useMemo, useState } from 'react';
import { Icon } from 'semantic-ui-react';

const ReleaseToast = ({
    open,
    onClose,
    onView,
    autoCloseDelay = 5000,
    title = "tenantBridge v3.1.0 Released",
    message = "New: License Generator, category-scoped Approval History for approvers, Expiring Licenses search UX, Multi-Tenancy View Details POC (Yes/No). See Release Notes for details.",
    icon = 'bell',
    showViewButton = true
}) => {
    const [visible, setVisible] = useState(false);
    const [progress, setProgress] = useState(100);

    const isActiveWindow = useMemo(() => true, []);

    useEffect(() => {
        if (open && isActiveWindow) {
            // Trigger slide-in animation
            const slideId = setTimeout(() => setVisible(true), 10);
            
            // Progress bar countdown
            const startTime = Date.now();
            const progressInterval = setInterval(() => {
                const elapsed = Date.now() - startTime;
                const remaining = Math.max(0, 100 - (elapsed / autoCloseDelay) * 100);
                setProgress(remaining);
            }, 16);

            // Auto close after delay
            const timer = setTimeout(() => {
                handleClose();
            }, autoCloseDelay);

            return () => {
                clearTimeout(slideId);
                clearTimeout(timer);
                clearInterval(progressInterval);
            };
        } else {
            setVisible(false);
            setProgress(100);
        }
    }, [open, isActiveWindow, autoCloseDelay]);

    const handleClose = () => {
        setVisible(false);
        setTimeout(() => onClose?.(), 300);
    };

    const handleView = () => {
        onView?.();
        handleClose();
    };

    if (!open || !isActiveWindow) return null;

    return (
        <div className={`tb-release-toast ${visible ? 'tb-toast-in' : 'tb-toast-out'}`} role="dialog" aria-live="polite" aria-labelledby="toast-title">
            <div className="tb-toast-content">
                <div className="tb-toast-header-row">
                    <span style={{ fontSize: '1.25em', lineHeight: 1, color: '#062D4D', minWidth: '20px', display: 'inline-flex', justifyContent: 'center' }}>
                        <Icon name={icon || 'bell'} />
                    </span>
                    <div className="tb-toast-text">
                        <div className="tb-toast-title" id="toast-title">{title}</div>
                        <div className="tb-toast-body">{message}</div>
                    </div>
                </div>
                <div className="tb-toast-actions">
                    {showViewButton && (
                        <button className="tb-btn tb-btn-primary" onClick={handleView}>View</button>
                    )}
                    <button className="tb-btn tb-btn-ghost" onClick={handleClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default ReleaseToast;